import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TBRPreRequisiteType } from '../../../pages/ifspNew/IfspMainScreen';
const initialState: TBRPreRequisiteType = {
  tbrIfspId: 0,
  ifspId: '',
  isTransitionChecked: false,
  isAlreadyTransitionChecked: false,
  isServiceDeliveryChecked: false,
  isAlreadyServiceDeliveryChecked: false,
  isOutcomeChecked: false,
  isAlreadyOutcomeChecked: false,
  isCommonAreaChecked: false,
  isAlreadyCommonAreaChecked: false,
  commonAreaReadyToUpload: false,
  outcomeReadyToUpload: false,
  serviceDeliveryReadyToUpload: false,
  transitionReadyToUpload: false,
  pendingUploadEvaluationToTbr: false,
};
const ifspTBRPreRequisiteSlice = createSlice({
  name: 'ifspTBRPreRequisite',
  initialState,
  reducers: {
    setTBRPreRequisite: (state, action: PayloadAction<TBRPreRequisiteType>) => {
      state.tbrIfspId = action.payload.tbrIfspId;
      state.ifspId = action.payload.ifspId;
      state.isTransitionChecked = action.payload.isTransitionChecked;
      state.isAlreadyTransitionChecked =
        action.payload.isAlreadyTransitionChecked;
      state.isServiceDeliveryChecked = action.payload.isServiceDeliveryChecked;
      state.isAlreadyServiceDeliveryChecked =
        action.payload.isAlreadyServiceDeliveryChecked;
      state.isOutcomeChecked = action.payload.isOutcomeChecked;
      state.isAlreadyOutcomeChecked = action.payload.isAlreadyOutcomeChecked;
      state.isCommonAreaChecked = action.payload.isCommonAreaChecked;
      state.isAlreadyCommonAreaChecked =
        action.payload.isAlreadyCommonAreaChecked;
      state.commonAreaReadyToUpload = action.payload.commonAreaReadyToUpload;
      state.outcomeReadyToUpload = action.payload.outcomeReadyToUpload;
      state.serviceDeliveryReadyToUpload =
        action.payload.serviceDeliveryReadyToUpload;
      state.transitionReadyToUpload = action.payload.transitionReadyToUpload;
      state.pendingUploadEvaluationToTbr =
        action.payload.pendingUploadEvaluationToTbr;
    },
    updateTBRPreRequisite: (
      state,
      action: PayloadAction<Partial<TBRPreRequisiteType>>,
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetTBRPreRequisite: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_REDUX_APP_STATES', () => initialState);
  },
});

export const {
  setTBRPreRequisite,
  updateTBRPreRequisite,
  resetTBRPreRequisite,
} = ifspTBRPreRequisiteSlice.actions;
export default ifspTBRPreRequisiteSlice.reducer;
